module.exports = __webpack_public_path__ + "img/report.a825910b.png";